import { MapPin, Phone, Mail, Clock, UserRound } from "lucide-react";
import { CONTACT } from "../../data/content";
import { Reveal, Eyebrow } from "./Reveal";

const ROWS = [
  { k: "address", label: "Visit", icon: MapPin },
  { k: "phone", label: "Call", icon: Phone },
  { k: "email", label: "Write", icon: Mail },
  { k: "hours", label: "OPD hours", icon: Clock },
  { k: "doctor", label: "Consulting doctor", icon: UserRound },
];

const HREF = { phone: `tel:+91${CONTACT.phone}`, email: `mailto:${CONTACT.email}` };

export const Contact = () => (
  <section id="contact" data-testid="contact-details-section" className="py-24 sm:py-36">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12">
      <Reveal className="lg:col-span-5">
        <Eyebrow>Contact</Eyebrow>
        <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#0B2B26]">
          Find us in <span className="italic text-[#0E4D44]">Bhopal.</span>
        </h2>
        <dl className="mt-12 space-y-6">
          {ROWS.map(({ k, label, icon: Icon }) => (
            <div key={k} className="flex gap-5">
              <span className="h-11 w-11 shrink-0 rounded-full bg-[#E6F0EE] text-[#0E4D44] grid place-items-center"><Icon className="h-4 w-4" /></span>
              <div>
                <dt className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#4A6660]">{label}</dt>
                <dd data-testid={`contact-${k}-text`} className="mt-1 text-base sm:text-lg text-[#0B2B26] whitespace-pre-line break-words">
                  {HREF[k] ? <a href={HREF[k]} className="hover:text-[#B4502C] transition-colors">{CONTACT[k]}</a> : CONTACT[k]}
                </dd>
              </div>
            </div>
          ))}
        </dl>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-7">
        <div className="rounded-[28px] overflow-hidden border border-[#0E4D44]/10 h-[360px] sm:h-[520px] bg-[#E6F0EE]">
          <iframe
            data-testid="contact-map"
            title="Bhopal map"
            src="https://www.google.com/maps?q=Meenakshi+Planet+City,+Bhopal,+Madhya+Pradesh&output=embed"
            className="h-full w-full grayscale-[60%] contrast-[1.05]"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
